import './index.scss';

const MODAL_TITLE_HEIGHT = 50;

export class ProductSetPickerColumnLayout extends HTMLElement {
  constructor() {
    super();
    this.onEventsBind = this.onEvents.bind(this);
  }
  connectedCallback() {
    this.bindEvents();
    this.createTitleViewObserver();
    this.initRender();
  }
  disconnectedCallback() {
    this.removeEventsListener();
  }
  removeEventsListener() {
    this.removeEventListener('click', this.onEventsBind);
  }
  bindEvents() {
    this.addEventListener('click', this.onEventsBind);
  }
  createTitleViewObserver() {
    const $title = this.querySelector(
      '.product-set-picker-column-layout__title',
    );
    const $titleTarget = this.querySelector(
      '[data-bind-product-set-picker-column-layout-title]',
    );

    if (!$title || !$titleTarget) {
      return;
    }

    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.renderTitleByShowStatus(!entry.isIntersecting);
      });
    });

    observer.observe($titleTarget);
  }
  onEvents(event) {
    if (event.target.closest('.js-close-product-set-modal')) {
      this.onClose();
    }
  }
  onClose() {
    this.closest('sl-modal').onHide();
  }
  initRender() {
    // NOTE: When the dom does not change, firefox may record the state, such as scrollTop, see https://shopline.atlassian.net/browse/SL-45731
    const $content = this.querySelector('.sl-column-layout__content');
    if ($content) {
      window.requestAnimationFrame(() => {
        $content.scrollTo({
          top: 0,
        });
      });
    }
  }
  scrollToElement($element) {
    if (!$element) {
      return;
    }

    const $content = this.querySelector('.sl-column-layout__content');
    if (
      !$content ||
      $element.closest('.sl-column-layout__content') !== $content
    ) {
      return;
    }

    const offsetTop = $element.offsetTop;
    $content.scrollTo({
      top: offsetTop - MODAL_TITLE_HEIGHT,
      behavior: 'smooth',
    });
  }
  renderTitleByShowStatus(showStatus) {
    const $title = this.querySelector(
      '.product-set-picker-column-layout__title',
    );
    if (showStatus) {
      $title.classList.add('product-set-picker-column-layout__title_show');
    } else {
      $title.classList.remove('product-set-picker-column-layout__title_show');
    }
  }
}

if (!customElements.get('product-set-picker-column-layout')) {
  customElements.define(
    'product-set-picker-column-layout',
    ProductSetPickerColumnLayout,
  );
}
